// extracted by mini-css-extract-plugin
module.exports = {"WorkWrapper":"Work-module--WorkWrapper--3c_Z5 reusable--flexWrapper--1szGd"};